import {
  DateFormat,
  useUserLocaleDateFormatting,
} from "@src/Hooks/useUserLocaleDateFormatting"
import { DateInfo } from "@src/Portal/Dashboard/TrainingCard/styles"
import { ITrainingDashboardData } from "@src/types"

import { Description, InfoMain, InfoName, InfoNumber } from "../../styles"

export const FilledStateCard = ({
  teamMembers = 0,
  isFinished = 0,
  isNotFinished = 0,
  lastUpdated,
}: Partial<ITrainingDashboardData>) => {
  const { formatDate } = useUserLocaleDateFormatting()

  return (
    <>
      <InfoMain hrHeight="88px">
        <InfoName>
          <InfoNumber>{teamMembers}</InfoNumber>
          <Description>
            Team
            <br />
            {teamMembers > 1 ? "Members" : "Member"}
            <br />
          </Description>
        </InfoName>
        <hr />
        <InfoName>
          <InfoNumber>{isFinished}</InfoNumber>
          <Description>Finished Assigned Modules</Description>
        </InfoName>
        <hr />
        <InfoName>
          <InfoNumber>{isNotFinished}</InfoNumber>
          <Description>With Incomplete Modules</Description>
        </InfoName>
      </InfoMain>
      {lastUpdated && (
        <DateInfo>
          Updated {formatDate(new Date(lastUpdated), DateFormat.Date)}
        </DateInfo>
      )}
    </>
  )
}
